'use client';

import { useMemo, type ReactNode } from 'react';

import { CopilotToolUiContext, type CopilotToolUiContextValue } from './CopilotToolUiContext';

import type { AddToolOutputFn } from '@/features/copilot/tooling/types';
import type { ToolPartRenderer } from '@/features/copilot/model';

export type { CopilotToolUiContextValue };

export interface CopilotToolUiProviderProps {
  toolPartRenderers: Readonly<Record<string, ToolPartRenderer>>;
  addToolOutput: AddToolOutputFn;
  onSendMessage?: (message: string) => void;
  children: ReactNode;
}

/**
 * Provides copilot tool UI wiring (renderer map + addToolOutput) once at the boundary.
 */
export function CopilotToolUiProvider({
  toolPartRenderers,
  addToolOutput,
  onSendMessage,
  children,
}: CopilotToolUiProviderProps) {
  const value = useMemo<CopilotToolUiContextValue>(
    () => ({
      toolPartRenderers,
      addToolOutput,
      onSendMessage,
    }),
    [toolPartRenderers, addToolOutput, onSendMessage]
  );

  return <CopilotToolUiContext.Provider value={value}>{children}</CopilotToolUiContext.Provider>;
}
